import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "c-item-list-heading" }
const _hoisted_2 = { class: "p-a01-heading" }
const _hoisted_3 = {
  key: 0,
  class: "c-item-list-heading__button_main"
}
const _hoisted_4 = { class: "c-item-list-heading__button_main__label" }
const _hoisted_5 = { class: "c-item-list-heading__button_main__label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconArrowRight = _resolveComponent("IconArrowRight")!
  const _component_IconBase = _resolveComponent("IconBase")!
  const _component_ButtonMain = _resolveComponent("ButtonMain")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.title), 1),
    (_ctx.localShowButton)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_ButtonMain, {
            tag: "a",
            href: _ctx.lifeUrl,
            style: {"background":"#089398"}
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.lifeText), 1),
              _createVNode(_component_IconBase, {
                width: 24,
                height: 24,
                "view-box": "0 0 24 24"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_IconArrowRight)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["href"]),
          _createVNode(_component_ButtonMain, {
            tag: "a",
            href: _ctx.goodsUrl,
            style: {"background":"#F36D0D"}
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.goodsText), 1),
              _createVNode(_component_IconBase, {
                width: 24,
                height: 24,
                "view-box": "0 0 24 24"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_IconArrowRight)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["href"])
        ]))
      : _createCommentVNode("", true)
  ]))
}